(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6451],{

/***/ 87376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ CardListWrapper; },
  "J": function() { return /* reexport */ ListingCardVertical; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/CardCasavoLogo/index.tsx + 1 modules
var CardCasavoLogo = __webpack_require__(45600);
// EXTERNAL MODULE: ./src/components/ListingCard/styles.css.ts
var styles_css = __webpack_require__(96845);
// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var shared_styles_styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/floors.tsx
var floors = __webpack_require__(21041);
// EXTERNAL MODULE: ./src/utils/format-listing-sellingPrice.ts
var format_listing_sellingPrice = __webpack_require__(65565);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/PropertyIcon/index.tsx
var PropertyIcon = __webpack_require__(7830);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/design-lib/components/Badge/index.tsx + 1 modules
var Badge = __webpack_require__(53964);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/components/FavouriteButton/index.tsx + 1 modules
var FavouriteButton = __webpack_require__(45931);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/components/Card/index.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Card/index.css.tsx.vanilla.css","source":"Lndicnp2NzAgewogIG1pbi1oZWlnaHQ6IDQycHg7Cn0KLndicnp2NzEgewogIGJvcmRlci10b3AtbGVmdC1yYWRpdXM6IDhweDsKICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogOHB4OwogIG9iamVjdC1maXQ6IGNvdmVyOwogIHBvc2l0aW9uOiByZWxhdGl2ZTsKICB3aWR0aDogMTAwJTsKfQoud2JyenY3MyB7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRkZGRjsKICBib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOiA4cHg7CiAgYm9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6IDhweDsKICBmbGV4OiAxOwp9Ci53YnJ6djc1IHsKICBoZWlnaHQ6IDIzcHg7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(60768);
;// CONCATENATED MODULE: ./src/components/Card/index.css.tsx


var cardBody = 'wbrzv73 tfghjgju tfghjggc tfghjghi tfghjgio tfghjg1u tfghjg7l';
var cardMainImage = 'wbrzv71';
var cardTitle = 'wbrzv70';
var iconsInnerWrapper = 'tfghjg0 tfghjg1u tfghjg73 tfghjgb6 tfghjgdu tfghjgff';
var iconsOuterWrapper = 'wbrzv75 tfghjg6 tfghjg1u tfghjg7i tfghjga6 tfghjgl6';
;// CONCATENATED MODULE: ./src/components/Card/index.tsx













var Card = /*#__PURE__*/ (0,react.memo)(function(props) {
    var device = (0,Device/* useDevice */.Fy)();
    var imageHeight = device === "desktop" ? 200 : 160;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            flex: 1,
            flexDirection: "column",
            maxWidth: "100%",
            width: "100%"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardMainImage,
                children: [
                    props.badge ? props.badge.left : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: props.image.alt,
                        className: classnames_default()("card-suggested", cardMainImage),
                        "data-testid": "card-main-img",
                        height: imageHeight,
                        src: props.image.src + "?auto=compress,format&h=" + imageHeight,
                        srcSet: props.image.src + "?auto=compress,format&h=" + imageHeight + "&dpr=1 1x," + props.image.src + "?auto=compress,format&h=" + imageHeight + "&dpr=2 2x," + props.image.src + "?auto=compress,format&h=" + imageHeight + "&dpr=3 3x",
                        style: {
                            height: imageHeight
                        },
                        width: "100%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardBody,
                children: [
                    props.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        className: classnames_default()(shared_styles_styles_css/* paddingBottom.xs */.Et.xs, shared_styles_styles_css/* ellipsis */.LH),
                        color: "greyscale500",
                        children: props.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        strong: true,
                        as: "h2",
                        className: cardTitle,
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "m"
                        }),
                        children: [
                            props.details.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "flex",
                                    gap: "s"
                                }),
                                children: props.details.map(function(detail, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: detail
                                    }, index);
                                })
                            }),
                            props.info.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "flex",
                                    gap: "m",
                                    marginTop: "auto"
                                }),
                                children: props.info.map(function(info, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                color: "greyscale500",
                                                children: info.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    alignItems: "center",
                                                    display: "flex",
                                                    gap: "xs"
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: info.text
                                                    }),
                                                    info.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyIcon/* default */.Z, {
                                                        kind: info.icon
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    props.favouriteEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginTop: "auto"
                        }),
                        children: [
                            ((props === null || props === void 0 ? void 0 : props.hasOutdoorSpace) || (props === null || props === void 0 ? void 0 : props.isHighEfficiency)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: iconsOuterWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: iconsInnerWrapper,
                                    children: [
                                        (props === null || props === void 0 ? void 0 : props.hasOutdoorSpace) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                marginRight: "xs"
                                            }),
                                            icon: "Tree",
                                            styleVariant: "greyscale"
                                        }),
                                        (props === null || props === void 0 ? void 0 : props.isHighEfficiency) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                marginRight: "xs"
                                            }),
                                            icon: "Sun",
                                            styleVariant: "greyscale"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        alignItems: "center",
                                        display: "flex",
                                        flexShrink: 0,
                                        justifyContent: "space-between",
                                        marginLeft: "auto"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                alignItems: "center",
                                                display: "flex"
                                            }),
                                            children: [
                                                props.isOwnedByCasavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                                    "aria-hidden": "true",
                                                    className: classnames_default()(shared_styles_styles_css/* marginRight.s */.wz.s, index_es/* colorVariants.orange600 */.Jj.orange600),
                                                    "data-testid": "casavo-ribbon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                                    children: props.price
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouriteButton/* FavouriteButton */.A, (0,_object_spread/* default */.Z)({
                                            gtmTouchpoint: props.favoriteButtonGtmTouchpoint,
                                            id: props.cardData.id
                                        }, props.favouriteClick ? {
                                            favouriteClick: function(e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                props.favouriteClick(props.cardData.id);
                                            }
                                        } : {}))
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "auto",
                            width: "100%"
                        }),
                        style: {
                            height: 23
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "flex-start",
                                    display: "flex",
                                    flex: 1,
                                    marginRight: "s",
                                    overflow: "hidden"
                                }),
                                children: [
                                    (props === null || props === void 0 ? void 0 : props.hasOutdoorSpace) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            marginRight: "xs"
                                        }),
                                        icon: "Tree",
                                        styleVariant: "greyscale"
                                    }),
                                    (props === null || props === void 0 ? void 0 : props.isHighEfficiency) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            marginRight: "xs"
                                        }),
                                        icon: "Sun",
                                        styleVariant: "greyscale"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "center",
                                    display: "flex",
                                    flexShrink: 0,
                                    marginLeft: "auto"
                                }),
                                children: [
                                    props.isOwnedByCasavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                        "aria-hidden": "true",
                                        className: classnames_default()(shared_styles_styles_css/* marginRight.s */.wz.s, index_es/* colorVariants.orange600 */.Jj.orange600),
                                        "data-testid": "casavo-ribbon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                        children: props.price
                                    })
                                ]
                            }),
                            props.favouriteEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouriteButton/* FavouriteButton */.A, (0,_object_spread/* default */.Z)({
                                    gtmTouchpoint: props.favoriteButtonGtmTouchpoint,
                                    id: props.cardData.id
                                }, props.favouriteClick ? {
                                    onClick: function() {
                                        return props.favouriteClick(props.cardData.id);
                                    }
                                } : {}))
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Card.displayName = "Card";
/* harmony default export */ var components_Card = (Card);

// EXTERNAL MODULE: src/components/ListingCardVertical/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ListingCardVertical/styles.css.ts.vanilla.css","source":"Ll8xY2E4c2IyMCB7CiAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7CiAgYW5pbWF0aW9uOiB0cmFuc2Zvcm0gMXMgZWFzZTsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGRkZGOwogIGJvcmRlci1yYWRpdXM6IDhweDsKICBib3gtc2hhZG93OiAwIDAgNnB4IDAgcmdiYSg1MSwgNjgsIDg0LCAwLjI0KTsKICBkaXNwbGF5OiBmbGV4OwogIGhlaWdodDogMTAwJTsKICB3aWR0aDogMTAwJTsKfQouXzFjYThzYjIwOmhvdmVyIHsKICBib3gtc2hhZG93OiAwIDAgMTBweCAwIHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(47492);
;// CONCATENATED MODULE: ./src/components/ListingCardVertical/styles.css.ts

var listingCardVerticalWrapper = '_1ca8sb20';
;// CONCATENATED MODULE: ./src/components/ListingCardVertical/ListingCardVertical.tsx















var ListingCardVertical = function(_param) {
    var cardData = _param.cardData, favoriteButtonGtmTouchpoint = _param.favoriteButtonGtmTouchpoint, favouriteClick = _param.favouriteClick, _favouriteEnabled = _param.favouriteEnabled, favouriteEnabled = _favouriteEnabled === void 0 ? false : _favouriteEnabled, onCardClick = _param.onCardClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "cardData",
        "favoriteButtonGtmTouchpoint",
        "favouriteClick",
        "favouriteEnabled",
        "onCardClick"
    ]);
    var ref, ref1;
    var ref2 = (0,useTranslation/* default */.Z)(), lang = ref2.lang, t = ref2.t;
    var cities = (0,Cities/* useCities */.M1)();
    var listingCity = cities.list.find(function(city) {
        return city.slug === cardData.city;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: listingCardVerticalWrapper,
        "data-testid": "listing-list",
        onClick: onCardClick
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
            badge: {
                left: cardData.ownedByCasavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCasavoLogo/* default */.Z, {
                    inventory: cardData.inventory,
                    isLabelVisible: true
                })
            },
            cardData: cardData,
            details: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                            as: "span",
                            children: cardData.commercialArea
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                            as: "span",
                            color: "greyscale500",
                            children: "m\xb2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                            as: "span",
                            className: shared_styles_styles_css/* marginRight.s */.wz.s,
                            children: (0,floors/* propertyFloorFormatter */.vH)({
                                buildingFloors: cardData.buildingFloors,
                                entireBuilding: cardData.entireBuilding,
                                entranceFloor: cardData.entranceFloor,
                                floorPosition: cardData.floorPosition
                            }, t)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                            as: "span",
                            color: "greyscale500",
                            children: (0,floors/* propertyFloorSuffix */.MN)({
                                buildingFloors: cardData.buildingFloors,
                                entireBuilding: cardData.entireBuilding,
                                entranceFloor: cardData.entranceFloor,
                                floorPosition: cardData.floorPosition
                            }, t)
                        })
                    ]
                }), 
            ],
            favoriteButtonGtmTouchpoint: favoriteButtonGtmTouchpoint,
            favouriteClick: favouriteClick,
            favouriteEnabled: favouriteEnabled,
            hasOutdoorSpace: cardData.hasOutdoorSpace,
            headline: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: (listingCity === null || listingCity === void 0 ? void 0 : listingCity.translatedCityName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: listingCity === null || listingCity === void 0 ? void 0 : listingCity.translatedCityName
                        }),
                        cardData.zone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: styles_css/* cardCityAreaDivider */.JS
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "data-testid": "listing-card-zone",
                                    children: cardData.zone.label
                                })
                            ]
                        })
                    ]
                })
            }),
            image: {
                alt: cardData.title,
                src: cardData.photos.length > 0 ? (ref = cardData.photos.find(function(photo) {
                    return photo.isPrimary;
                }) || cardData.photos[0]) === null || ref === void 0 ? void 0 : ref.url : ""
            },
            info: [
                {
                    heading: t("common:rooms"),
                    icon: "rooms",
                    text: cardData["rooms"]
                },
                {
                    heading: t("common:bathrooms"),
                    icon: "bathroom",
                    text: cardData.bathrooms
                },
                {
                    heading: t("common:status"),
                    text: t("common:".concat(cardData.stateOfMaintenance.toLowerCase()))
                }, 
            ],
            isHighEfficiency: [
                "a",
                "aplus",
                "b"
            ].includes((ref1 = cardData.energyRating) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
            isOwnedByCasavo: cardData.ownedByCasavo,
            labels: {
                highEfficienyLabel: "",
                outdoorSpaceLabel: ""
            },
            price: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(cardData.isPrivateNegotiation, cardData.price, t, lang),
            title: cardData.title
        })
    }));
};

// EXTERNAL MODULE: src/components/ListingCardVertical/CardListWrapper/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ListingCardVertical/CardListWrapper/styles.css.ts.vanilla.css","source":"Lm1vcGV5MDEgewogIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KGF1dG8tZmlsbCwgMzI4cHgpOwp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(14312);
;// CONCATENATED MODULE: ./src/components/ListingCardVertical/CardListWrapper/styles.css.ts


var cardListWrapper = 'mopey01 _1b5wm202k _1b5wm202y tfghjg1x tfghjgac tfghjggc _1b5wm201q _1b5wm201r';
;// CONCATENATED MODULE: ./src/components/ListingCardVertical/CardListWrapper/CardListWrapper.tsx


var CardListWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cardListWrapper,
        children: [
            " ",
            children,
            " "
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ListingCardVertical/CardListWrapper/index.ts


;// CONCATENATED MODULE: ./src/components/ListingCardVertical/index.ts




/***/ }),

/***/ 7830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68032);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_1__);


var PropertyIcon = function(props) {
    var iconComponentName = lodash_capitalize__WEBPACK_IMPORTED_MODULE_1___default()(props.kind);
    var Icon = (__webpack_require__(81016)/* ["default"] */ .Z)[iconComponentName];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
        height: 12,
        width: 12
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PropertyIcon);


/***/ }),

/***/ 15099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qX": function() { return /* binding */ parsePotentialPropertyMedia; }
/* harmony export */ });
/* unused harmony exports cardPhotos, remapPriorityMedia */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62271);
/* harmony import */ var fp_ts_Array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88401);
/* harmony import */ var fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63820);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13795);





var floorPlanType = io_ts__WEBPACK_IMPORTED_MODULE_0__/* .type */ .dt({
    url: io_ts__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_
});
var cardPhotos = io_ts__WEBPACK_IMPORTED_MODULE_0__/* .type */ .dt({
    isPrimary: io_ts__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7,
    url: io_ts__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_
});
var OrderedRoomType;
(function(OrderedRoomType) {
    OrderedRoomType[OrderedRoomType["living_dining_room"] = 0] = "living_dining_room";
    OrderedRoomType[OrderedRoomType["bedroom"] = 1] = "bedroom";
    OrderedRoomType[OrderedRoomType["kitchen"] = 2] = "kitchen";
    OrderedRoomType[OrderedRoomType["bathroom"] = 3] = "bathroom";
    OrderedRoomType[OrderedRoomType["floor_plan"] = 4] = "floor_plan";
    OrderedRoomType[OrderedRoomType["unknown"] = 5] = "unknown";
})(OrderedRoomType || (OrderedRoomType = {}));
var remapPriorityMedia = function(mediaItem) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, mediaItem), {
        isPrimary: false,
        roomTypeOrder: mediaItem.roomType ? OrderedRoomType[mediaItem.roomType] : OrderedRoomType.unknown
    });
};
var parsePotentialPropertyMedia = function(potentialPropertyMedia) {
    var floorPlanFiltered = potentialPropertyMedia.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.imageCategory) === "floorPlan";
    });
    var floorPlan = (0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(floorPlanFiltered, fp_ts_Array__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(floorPlanType.decode), fp_ts_Array__WEBPACK_IMPORTED_MODULE_4__/* .rights */ .hp);
    var sorted = potentialPropertyMedia.filter(function(item) {
        return item.imageCategory !== "floorPlan";
    }).map(remapPriorityMedia).sort(function(a, b) {
        if (a.roomTypeOrder === b.roomTypeOrder) {
            var _roomTypeConfidence;
            var roomTypeConfidenceA = (_roomTypeConfidence = a.roomTypeConfidence) !== null && _roomTypeConfidence !== void 0 ? _roomTypeConfidence : 0;
            var _roomTypeConfidence1;
            var roomTypeConfidenceB = (_roomTypeConfidence1 = b.roomTypeConfidence) !== null && _roomTypeConfidence1 !== void 0 ? _roomTypeConfidence1 : 0;
            return roomTypeConfidenceB - roomTypeConfidenceA;
        }
        return a.roomTypeOrder - b.roomTypeOrder;
    }).map(function(param) {
        var isPrimary = param.isPrimary, url = param.url;
        return {
            isPrimary: isPrimary,
            url: url
        };
    });
    var photoGallery = (0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(sorted, fp_ts_Array__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(cardPhotos.decode), fp_ts_Array__WEBPACK_IMPORTED_MODULE_4__/* .rights */ .hp);
    return {
        floorPlan: floorPlan,
        photoGallery: photoGallery
    };
};


/***/ }),

/***/ 10935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ isCardPriority; },
/* harmony export */   "u": function() { return /* binding */ PropertyType; }
/* harmony export */ });
var PropertyType;
(function(PropertyType) {
    PropertyType["Listing"] = "listing";
    PropertyType["Priority"] = "priority";
})(PropertyType || (PropertyType = {}));
var isCardPriority = function(cardData) {
    return cardData.type === PropertyType.Priority;
};


/***/ }),

/***/ 26100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ mapListingsIntoCardDataListing; },
/* harmony export */   "nS": function() { return /* binding */ mapPrioritiesIntoCardDataPriority; }
/* harmony export */ });
/* unused harmony export mapListingPhotosIntoCardPhotos */
/* harmony import */ var _containers_PriorityDetail_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15099);
/* harmony import */ var _types_property_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10935);
/* harmony import */ var _balcony_counter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96417);
/* harmony import */ var _get_translated_title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22862);




var mapListingPhotosIntoCardPhotos = function(propertyPhotos) {
    return propertyPhotos.map(function(photo) {
        return {
            isPrimary: photo.isPrimary,
            url: photo.url
        };
    });
};
var mapPrioritiesIntoCardDataPriority = function(priorities) {
    var ref, ref1, ref2, ref3;
    return priorities.map(function(priority) {
        var ref4, ref5, ref6, ref7;
        return {
            bathrooms: priority.bathrooms,
            buildingFloors: priority.buildingFloors,
            city: priority.city,
            commercialArea: priority.commercialArea,
            energyRating: priority.energyRatingClass,
            entranceFloor: priority.entranceFloor,
            estimatedListingPrice: {
                cents: (ref = (ref4 = priority.estimatedListingPrice) === null || ref4 === void 0 ? void 0 : ref4.cents) !== null && ref !== void 0 ? ref : 0,
                currency: (ref1 = (ref5 = priority.estimatedListingPrice) === null || ref5 === void 0 ? void 0 : ref5.currency) !== null && ref1 !== void 0 ? ref1 : "eur"
            },
            floorPosition: [],
            //TODO: check the data coming from terraceAreas and gardenAreas
            hasOutdoorSpace: false,
            id: priority.transactionId,
            insertedAt: priority.insertedAt,
            photos: (0,_containers_PriorityDetail_utils__WEBPACK_IMPORTED_MODULE_0__/* .parsePotentialPropertyMedia */ .qX)(priority.potentialPropertyMedia).photoGallery,
            price: {
                cents: (ref2 = (ref6 = priority.askedPrice) === null || ref6 === void 0 ? void 0 : ref6.cents) !== null && ref2 !== void 0 ? ref2 : 0,
                currency: (ref3 = (ref7 = priority.askedPrice) === null || ref7 === void 0 ? void 0 : ref7.currency) !== null && ref3 !== void 0 ? ref3 : "eur"
            },
            rooms: priority.rooms,
            slug: priority.slug,
            stateOfMaintenance: priority.stateOfMaintenance,
            status: priority.status,
            title: priority.title,
            type: _types_property_card__WEBPACK_IMPORTED_MODULE_1__/* .PropertyType.Priority */ .u.Priority,
            zone: priority.zone
        };
    });
};
var mapListingsIntoCardDataListing = function(listings, locale) {
    return listings.map(function(listing) {
        var ref, ref1;
        var ref2, ref3, ref4;
        return {
            bathrooms: listing.characteristics.bathrooms,
            buildingFloors: listing.detail.buildingFloors,
            city: listing.detail.city,
            commercialArea: listing.detail.commercialArea,
            energyRating: listing.additionalInfo.energyRating,
            entireBuilding: listing.detail.entireBuilding,
            entranceFloor: listing.detail.entranceFloor,
            floorPosition: listing.detail.floorPosition,
            hasOutdoorSpace: (ref2 = _balcony_counter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(listing.characteristics.terraces) > 0 || listing.services.garden) !== null && ref2 !== void 0 ? ref2 : false,
            id: listing.id,
            inventory: listing.detail.inventory,
            isPrivateNegotiation: listing.detail.privateNegotiation,
            ownedByCasavo: listing.contactInfo.ownedByCasavo,
            photos: mapListingPhotosIntoCardPhotos(listing.photos),
            price: {
                cents: (ref3 = (ref = listing.detail.sellingPrices) === null || ref === void 0 ? void 0 : ref.cents) !== null && ref3 !== void 0 ? ref3 : 0,
                currency: (ref4 = (ref1 = listing.detail.sellingPrices) === null || ref1 === void 0 ? void 0 : ref1.currency) !== null && ref4 !== void 0 ? ref4 : "eur"
            },
            rooms: listing.characteristics.rooms,
            stateOfMaintenance: listing.characteristics.stateOfMaintenance,
            title: (0,_get_translated_title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(listing.detail.titles, locale),
            type: _types_property_card__WEBPACK_IMPORTED_MODULE_1__/* .PropertyType.Listing */ .u.Listing,
            zone: listing.detail.zone
        };
    });
};


/***/ }),

/***/ 60768:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 14312:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 47492:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);